import { LazyLoadImage as ReactLazyLoadImage } from "react-lazy-load-image-component";
import styled from "styled-components";

import { CheckboxInput } from "components/atoms/Checkbox/Checkbox.styled";
import { colourScheme } from "utils/styling/colours";

export const LazyLoadImage = styled(ReactLazyLoadImage)<{
    $isSelected: boolean;
}>`
    border: ${({ $isSelected }) =>
        $isSelected ? `0.2rem solid ${colourScheme.error}` : "none"};
    border-radius: 0.5rem;
    max-width: 100%;
    height: auto;
    object-fit: cover;
`;

export const ImageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    padding: 0.5rem;
    position: relative;

    & > a {
        text-align: center;
    }

    & img {
        border-radius: 0.5rem;
        width: 100%;
        max-width: 15rem;
        object-fit: cover;
        height: auto;
        max-height: 15rem;
    }

    &:hover {
        transform: scale(1.03);
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
    }

    &:hover ${CheckboxInput} + label::before {
        opacity: 1;
    }

    &:hover ${CheckboxInput}:checked + label::before {
        background: ${colourScheme.error};
    }
`;
